module.exports = __webpack_public_path__ + "static/media/fotos-05.5cb417bf.jpg";